export default function CasavioLogo({ size = 24, color = '#B8721F', style = {} }) {
  const icon = Math.round(size * 1.25)
  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: Math.round(size * 0.3), ...style }}>
      <svg width={icon} height={icon} viewBox="0 0 32 32" fill="none">
        <path d="M16 3L31 15H27V29H5V15H1L16 3Z" fill={color} />
        <rect x="12" y="20" width="8" height="9" rx="1" fill="white" fillOpacity="0.55" />
      </svg>
      <span style={{
        fontFamily: 'Georgia, serif',
        fontSize: `${size}px`,
        fontWeight: '700',
        color,
        letterSpacing: `${Math.round(size * 0.14)}px`,
        lineHeight: 1,
      }}>
        CASAVIO
      </span>
    </div>
  )
}
